<app-modal-area
  title="CLIENTS_INFO.TITLE"
  hiddenLoading
>
  <div>
    <span><strong>{{ 'CLIENTS_INFO.PDV_QUANTITY' | translate }}:</strong> {{ clientInfo.pdvQuantity }}</span>
    <span><strong>{{ 'CLIENTS_INFO.MONTHLY_FEE' | translate }}:</strong> R$ {{ clientInfo.monthlyFee }}</span>
  </div>

  <hr class="separator">

  <div class="observation-area">
    <span><strong>{{ 'CLIENTS_INFO.OBSERVATION' | translate }}:</strong> {{ clientInfo.observation }}</span>
  </div>

  <hr class="separator">

  <button class="button primary" (click)="handleClickDownloadContract()">
    <i class="material-symbols-outlined">
      download
    </i>
    {{ 'CLIENTS_INFO.DOWNLOAD_CONTRACT' | translate }}
  </button>
</app-modal-area>
